import axios, { ResponseType } from "axios";
import { SERVER_URL } from "../config/config";

class MemberServices {
  private static serverURL = SERVER_URL;

  public static async getMemberList(searchParameters: any) {
    console.log("searchParameters-service", searchParameters);
    console.log("searchParameters-Page", searchParameters);
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response1", response);
    return response;
  }

  public static async getMember(memberId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("DsbaAdminToken 12:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/${memberId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async getLastYearSections(memberId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("DsbaAdminToken 12:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/lastyearsections/${memberId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("lastyearsections response", response);
    return response;
  }

  public static async getConfigurationList() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("DsbaAdminToken 13:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/configuration`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async getSavedSearchList() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("DsbaAdminToken 13:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/search/list`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createMember(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async saveSearchQuery(searchParameters: any) {
    // console.log("getMemberList11");
    // const searchParameters = useSelector(
    // 	(state: RootState) => state.searchMemberApiSlice
    //   );
    console.log("searchParameters-service", searchParameters);
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/search`;
    const response = await axios.post(apiUrl, searchParameters, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async executeSavedSearch(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("executeSavedQuery", body);
    const apiUrl = `${this.serverURL}/api/member/search/execute`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async editMemberPersonal(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/personal`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async editMemberCode(body: any) {
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/membercode`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async editMemberTags(body: any) {
    console.log("tag1 :", body);
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/tags`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async editMemberAddress(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/address`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async editMemberSections(body: any) {
    console.log("section1 :", body);
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/sections`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

    public static async updateOfficerResponsibility(body: {
        MemberId: number | null;
        SectionId: number;
        HasSectionOfficerResponsibility: boolean;
    }) {
        const axiosConfig = {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                ApiKey: process.env.REACT_APP_API_KEY,
                SessionToken: sessionStorage.getItem("DsbaAdminToken"),
            },
        };

        const apiUrl = `${this.serverURL}/api/member/officers`;
        return axios.put(apiUrl, body, axiosConfig);
    }

  public static async editMemberOtherStateBar(body: any) {
    console.log("otherStatebar :", body);
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/other-bar`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getMemberLabels(searchParameters: any) {
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/envelope`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getAllMemberLabels(searchParameters: any) {
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/envelope-all-members`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async downloaMemberList(searchParameters: any) {
    console.log("downloaMemberList");
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
      responseType: "arraybuffer" as ResponseType,
    };
    console.log("axiosConfig", axiosConfig);
    const apiUrl = `${this.serverURL}/api/member/export`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async downloadPendingInvoices(searchParameters: any) {
    console.log("downloaMemberList");
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    console.log("axiosConfig", axiosConfig);
    const apiUrl = `${this.serverURL}/api/member/download-pending-invoices`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async downloadMergedPendingInvoices(searchParameters: any) {
    //try {
    let parameteres = searchParameters;
    const response = await axios.get(
      `${this.serverURL}/api/member/download-merged-pending-invoices`,
      {
        headers: {
          "Content-Type": "application/json",
          ApiKey: process.env.REACT_APP_API_KEY,
          SessionToken: sessionStorage.getItem("DsbaAdminToken") || "",
        },
        responseType: "blob",
        params: parameteres,
        timeout: 120000,
      },
    );

    //} catch (error) {
    //  console.error('Download failed:', error);
    //}
    return response;
  }

  public static async sendInvoiceEmailToMember(body: any) {
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/send-member-invoice`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async sendReceiptEmailToMember(body: any) {
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/send-member-receipt`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async sendCLEReceiptEmailToMember(body: any) {
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/send-CLE-receipt`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async sendGuestCLEReceiptEmailToMember(body: any) {
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/send-guest-CLE-receipt`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async sendEmailToFirmMembers(body: any) {
    // return;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMember", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/email`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async checkIsBarIdDuplicate(searchParameters: any) {
    console.log("downloaMemberList");
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    console.log("axiosConfig", axiosConfig);
    const apiUrl = `${this.serverURL}/api/member/memberId/isDuplicate`;
    const response = await axios.get(apiUrl, axiosConfig);
    return response;
  }

  public static async getFirmDetailList() {
    console.log("FirmDetailList");
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("axiosConfig", axiosConfig);
    const apiUrl = `${this.serverURL}/api/firm`;
    const response = await axios.get(apiUrl, axiosConfig);
    return response;
  }

  public static async deleteMember(memberId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    const apiUrl = `${this.serverURL}/api/member/${memberId}`;
    const response = await axios.delete(apiUrl, axiosConfig);
    return response;
  }

  public static async getMemberEditHistory(queryParameter: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: queryParameter,
    };
    console.log("DsbaAdminToken 13:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/member/edit-history`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }
}

export default MemberServices;

// axios.interceptors.response.use(
// 	(res) => {
// 		return res;
// 	},
// 	(err) => {
// 		if (err.response.data.error.errorCode == 401) {
// 			console.log("unauth erro");
// 			console.log("loc", window.location.pathname);
// 			sessionStorage.removeItem("DsbaAdminToken");
// 			alert("Token Expired Please Login again");
// 			// let html = <h1>hello </h1>
// 			window.location.href = "/sign-in/?path=" + window.location.pathname; //working
// 		}
// 		return Promise.reject(err);
// 	}
// );
